import { Component, OnInit } from '@angular/core';
import { ApprovedDate } from '../../_models/approved-date';
import { ReportService } from '../../_services';
import { GlobalDataService } from '../../_shared';
import { LoginUser } from '../../_models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';

@Component({
  standalone: false,
  selector: 'app-set-approveddate',
  templateUrl: './set-approveddate.component.html',
  styleUrls: ['./set-approveddate.component.css']
})
export class SetApproveddateComponent implements OnInit {

  approvedDateModel!: ApprovedDate;
  ApprDt :any;
  user!: LoginUser;
  constructor(
    private reportService  : ReportService,private gd : GlobalDataService,private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.user = this.gd.getUserData();
    this.GetApprovedDate();
  }
  
  GetApprovedDate(){
    this.reportService.getApprovedDate().subscribe(res => {
      if(res!=null)
      {
        this.ApprDt = {
          "year": new Date(res.ApproveDate).getFullYear(),
          "month":  new Date(res.ApproveDate).getMonth()+1,
          "day": new Date(res.ApproveDate).getDate()
        }
      }
    });
  }

  OnSubmit(){
    this.approvedDateModel = {
      Id:0,
      ApproveDate :this.gd.convertToStandardDate(  this.ApprDt ) ,
      CreatedDate :new Date(),
      CreatedBy : this.user.ProvisioningID
    }
    this.reportService.addApprovedDate(this.approvedDateModel).subscribe(res => {
         this.openAlertModal("Record Saved Successfully");
    });
  }
  
  openAlertModal(strmsg: string) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }
}
